import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useFichario } from '../context/ficharioContext';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

export default function CaptchaGate({ children }) {
  const {
    needCaptcha,
    captchaValidated,
    validateCaptchaAndFetch,
  } = useFichario();

  const onCaptchaChange = async (token) => {
    //console.log("🔐 CAPTCHA token recebido:", token);
    await validateCaptchaAndFetch(token);
  };

  if (needCaptcha && !captchaValidated) {
    return (
      <div className="captcha-container center">
        <p>Por favor, confirme que você não é um robô para continuar.</p>
        <ReCAPTCHA className="top-margin" sitekey={SITE_KEY} onChange={onCaptchaChange} />
      </div>
    );
  }

  return <>{children}</>;
}
